import React from "react";
import {
  Button,
  Card,
  Container,
  Divider,
  Grid,
  Header,
  Icon,
  Image,
  List,
  Menu,
  Segment,
  Sidebar,
  Visibility,
} from "semantic-ui-react";
import CardRight from "../Components/CardRight";
import CardLeft from "../Components/CardLeft";
import CardLose from "../Components/CardLose";
import CardWin from "../Components/CardWin";

function HomePage() {
  const style = {
    h1: {
      marginTop: "1.5em",
      marginBottom: "0em",
      fontSize: "2.5em",
    },
    h2: {
      margin: "3em 0em 0em",
      marginBottom: "1em",
    },
    h2Custom: {
      margin: "3em 0em 0em",
      marginBottom: "0.5em",
    },
    h3: {
      marginTop: "0em",
      padding: "2em 0em",
      marginBottom: "0em",
    },
    hn: {
      fontSize: "1.5em",
    },
    last: {
      marginBottom: "300px",
    },
  };
  return (
    <div>
      <Header as="h1" inverted style={style.h1} textAlign="center">
        <Icon color="green" name="spotify" />
        Spotify Higher or Lower
      </Header>
      <Header.Subheader style={{ color: "#A9A9A9	", textAlign: "center" }}>
        Created by Ronan Almeida
      </Header.Subheader>
 
      {/* <Divider /> */}

      {/* <Header
        as="h2"
        inverted
        content="Select The Most Popular Artist By Popularity"
        style={style.h2}
        textAlign="center"
      />
      <Header /> */}

      <Header as="h2" inverted style={style.h2} textAlign="center">
        Select The Most Popular Artist By Popularity
      </Header>

      <Grid>
        <Grid.Column textAlign="center">
          <Button.Group style={{ textAlign: "center" }}>
            <Button active inverted color="green">
              <Icon name="user" />
              Artists
            </Button>
            <Button disabled inverted color="green">
              <Icon name="list" />
              Albums
            </Button>
            <Button disabled inverted color="green">
              <Icon name="play circle" />
              Songs
            </Button>
          </Button.Group>
        </Grid.Column>
      </Grid>
 

      <Header as="h3" inverted content="" textAlign="center" style={style.h3} />

      <Divider horizontal>
        {" "}
        <Header as="h2">
          <Icon
            style={{
              // marginTop: "5em",
              textAlign: "center",
              // position: "absolute",
              // left: "0",
              // bottom: "0"
            }}
            name="caret up"
            inverted
            color="green"
          ></Icon>
          <Icon
            style={{
              // marginTop: "5em",
              textAlign: "center",
              // position: "absolute",
              // left: "0",
              // bottom: "0"
            }}
            name="caret down"
            inverted
            color="red"
          ></Icon>
        </Header>
        {/* <Icon
         
          // size="large"
          
          color="green"
          name="angle double down"
        /> */}
      </Divider>
      <Header as="h1" textAlign="center" inverted sub>
        Current Artists
      </Header>

      <Container>
        <Grid celled="internally" columns={2}>
          <Grid.Row>
            <Grid.Column>
              <CardLeft
                img="https://i.scdn.co/image/d9a875c37277c35b94c60c00d2cd256db098505d"
                name="The Weeknd"
                items={[
                  ["contemporary r&b", "black"],
                  ["pop", "black"],
                  ["canadian pop", "black"],
                ]}
              />
            </Grid.Column>

            <Grid.Column>
              <CardLose
                img="https://i.scdn.co/image/a37efbc7fd3f5f5df81b48ce9c6de53820b239c1"
                name="Taylor Swift"
                items={[
                  ["mumble rap", "black"],
                  ["hiphop", "black"],
                  ["rock", "black"],
                ]}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
      {/* <Grid celled columns={2}>
        <Grid.Row>
          <Grid.Column>
            <CardLeft
              img="https://i.scdn.co/image/271c672ac7a84a95f3c557177a29b8936923d152"
              name="Lil Uzi Vert"
              items={[
                ["mumble rap", "black"],
                ["hiphop", "black"],
                ["rock", "black"],
              ]}
            />
          </Grid.Column>
          <Grid.Column>
            <CardArt
              img="https://i.scdn.co/image/a47ceed38754e29c1b2c0cb381b005030cbf1ced"
              name="Playboi Carti"
              items={[
                ["mumble rap", "black"],
                ["hiphop", "black"],
                ["rock", "black"],
              ]}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid> */}

      {/* <Segment style={{backgroundColor:"#252839"}}> */}
      {/* https://i.scdn.co/image/271c672ac7a84a95f3c557177a29b8936923d152 */}
      {/* <Grid container columns={2} stackable>
        <Grid.Column>
          <CardLeft
            img="https://i.scdn.co/image/271c672ac7a84a95f3c557177a29b8936923d152"
            name="Lil Uzi Vert"
            items={[
              ["mumble rap", "black"],
              ["hiphop", "black"],
              ["rock", "black"],
            ]}
          />
        </Grid.Column>
        <Grid.Column>
          <CardArt
            img="https://i.scdn.co/image/a47ceed38754e29c1b2c0cb381b005030cbf1ced"
            name="Playboi Carti"
            items={[
              ["mumble rap", "black"],
              ["hiphop", "black"],
              ["rock", "black"],
            ]}
          />
        </Grid.Column>
      </Grid> */}
      {/* <Segment
        inverted
        color="green"
        vertical
        style={{ padding: "2em 0em", marginTop: "10em" }}
      >
        <Container>
          <Grid divided inverted stackable>
            <Grid.Row>
              <Grid.Column width={8}>
                <Header as="h4" inverted>
                  Copyright
                </Header>

                <List link inverted>
                  <List.Item as="a">
                    Designed and Developed by Ronan Almeida ©
                  </List.Item>
                </List>
              </Grid.Column>

              <Grid.Column width={8}>
                <Header inverted as="h4" content="Contact Me" />
                <List link inverted>
                  <List.Item as="a">Email</List.Item>
                  <List.Item as="a">Portfolio Site</List.Item>
                </List>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Container>
      </Segment> */}
           <Header as="h3" inverted style={style.h2Custom} textAlign="center">
      🚧  Note: Site is Currently Under Development 🚧
      </Header>
      <Segment
        inverted
        color="green"
        style={{ margin: "5em 0em 0em", padding: "0.5em 0em" }}
        vertical
      >
        <Container textAlign="center">
          {/* <Divider inverted section /> */}
          {/* <Image src="/logo.png" centered size="mini" /> */}
          <List horizontal inverted divided link size="small">
            <List.Item
              as="a"
              target="_blank"
              href="https://developer.spotify.com/documentation/web-api/"
            >
              Powered by the Spotify Web API
            </List.Item>
            <List.Item as="a" target="_blank" href="https://ronan.tech/">
              Designed and Developed by Ronan Almeida ©
            </List.Item>
            <List.Item
              as="a"
              target="_blank"
              href="mailto: ronan.almeida@queensu.ca"
            >
              Email
            </List.Item>

            <List.Item as="a" target="_blank" href="https://ronan.tech/">
              Portfolio Site
            </List.Item>
          </List>
        </Container>
      </Segment>
      
    </div>
  );
}
export default HomePage;
